export default "__VITE_ASSET__B05RbKu2__"